import React from "react";
import WidgetReference from './WidgetReference';

export default function EmailSignupRewards() {
  return (
    <>
      <WidgetReference guideId="email-signup-rewards" />
    <iframe
      src="https://scribehow.com/o/_ygSvBcHTUyj_X5hGoV2bw/viewer/Configuring_Email_Signup_Rewards_in_Cleansweeps__FuwEVnXVTauZmUhm8jrvWA"
      height="640"
      title="Email Signup Entries"
      allowFullScreen
    />
    </>
  );
}
